if (!global._babelPolyfill) {
	require('babel-polyfill');
}

import React, {Component} from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import reactInterface from './utils/reactInterface'; // eslint-disable-line no-unused-vars
import IntlProvider from 'toluna-frontend-components/IntlProvider';
import {LocalizedApp} from './App';


const {helpers, apis} = reactInterface;

export {helpers, apis};


/*******/
const translations = {

  'translation': 'my first translation',
  'translationWithParams': 'my second translation. arg0={0}, arg1={1}'
};

/*************/

const bodyContainerHTML = document.getElementById('bodyContainer').innerHTML;


render(
  <Provider store={configureStore()}>
    <IntlProvider
      translations={translations}>

      <LocalizedApp />

    </IntlProvider>
  </Provider>,
  document.getElementById('bodyContainer')
);
document.getElementById('ta-react-app').insertAdjacentHTML('beforeend', bodyContainerHTML);

if (module.hot && process.env.NODE_ENV === "development") {
  console.log('Enabling HMR');
  module.hot.accept();
}




// WEBPACK FOOTER //
// ./index.js